import { Component, OnInit } from '@angular/core';
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

@Component({
  selector: 'app-weather-card-skeleton',
  templateUrl: './weather-card-skeleton.component.html',
  styleUrls: ['./weather-card-skeleton.component.scss'],
  imports: [
    NgxSkeletonLoaderModule
  ],
  standalone: true
})
export class WeatherCardSkeletonComponent  implements OnInit {

  skeletonDotTheme = {
    width: '8px',
    height: '8px',
    'border-radius': '50%',
    margin: '0'
  };

  skeletonLiveLabelTheme = {
    width: '30px',
    height: '10px',
    margin: '0'
  };

  skeletonAirLabelTheme = {
    width: '80px',
    height: '11px',
    margin: '0 0 4px'
  };

  skeletonAirValueTheme = {
    width: '60px',
    height: '10px',
    margin: '0'
  };

  skeletonIconTheme = {
    width: '36px',
    height: '36px',
    'border-radius': '50%',
    margin: '0'
  };

  skeletonConditionTheme = {
    width: '50px',
    height: '11px',
    margin: '0 0 6px'
  };

  skeletonTempTheme = {
    width: '70px',
    height: '20px',
    margin: '0'
  };

  constructor() { }

  ngOnInit() {}

}
